export const isValidUUID = (uuid) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

export const isValidNodeId = (nodeId) => {
  // Node IDs should be numeric
  return /^\d+$/.test(nodeId);
};

export const isValidNodeID = (nodeId) => {
  return /^\d+$/.test(nodeId);
};

export const sanitizeQueryParam = (param) => {
  if (typeof param !== 'string') return '';
  return param.replace(/[^a-zA-Z0-9-_|]/g, '');
};

export const validateAndLog = (type, value) => {
  let valid = true;
  
  switch(type) {
    case 'uuid':
      valid = isValidUUID(value);
      break;
    case 'nodeId':
      valid = isValidNodeId(value);
      break;
    default:
      valid = true;
  }
  
  if (!valid && process.env.NODE_ENV === 'development') {
    console.warn(`Invalid ${type}: ${value}`);
  }
  
  return { value, valid };
};